import React, { FC, useState } from 'react';
import { Dialog } from '../Dialog/Dialog';
import { DataTableTypes, FileFormat } from '../DataTable-v8';
import { Button } from '../Button/Button';
import { AppForm } from '../Form/AppForm';
import { useIntlUds } from '../../translations/UdsIntlProvider';
import { useTranslatedFileFormatOptions } from '../DataTable-v8/DataTableAdvancedElements/DataTableQuickReports/utils/useTranslatedOptions';

export type ExportFileFormats = DataTableTypes.FileFormat;

export interface ExportDialogProps {
  onClose: () => void;
  open: boolean;
  loading: boolean;
  message?: JSX.Element;
  onExport: (fileFormat: ExportFileFormats) => void;
  children?: React.ReactNode;
  fileFormats?: FileFormat[];
}

export const ExportDialog: FC<ExportDialogProps> = ({
  fileFormats,
  onClose,
  loading,
  onExport,
  open,
  message,
  children
}) => {
  const [fileFormat, setFileFormat] = useState<{ fileFormat: ExportFileFormats }>({ fileFormat: 'CSV' });
  const { intl } = useIntlUds();

  const fileFormatOptions = useTranslatedFileFormatOptions(fileFormats ?? ['CSV', 'XLSX']);

  return (
    <Dialog
      dataTest="export-dialog"
      title="Export"
      subTitle={message}
      open={open}
      onClose={onClose}
      showCancelButton
      actions={[
        <Button
          loading={loading}
          key="export-submit-button"
          dataTest="dialog-confirm-button"
          variant="contained"
          color="primary"
          onClick={() => onExport(fileFormat.fileFormat)}
        >
          {intl.ExportDialog.title}
        </Button>
      ]}
    >
      <AppForm initialValues={{ fileFormat: 'CSV' }} onChange={setFileFormat}>
        <AppForm.Control name="fileFormat" marginBottom={0}>
          <AppForm.Label>{intl.ExportDialog.fileFormatInput.label}</AppForm.Label>
          <AppForm.Select disableClearable options={fileFormatOptions} />
        </AppForm.Control>
      </AppForm>
      {children}
    </Dialog>
  );
};
